import { combineReducers } from 'lib/misc';
import { CoreState } from 'module/Core';
import { lastGridRouteEntity } from './lastGridRouteEntity';
import { MelezeConfigPreview } from 'module/Model/MelezeConfig';
import { PathUtils } from 'module/Common';
import { Reducer } from 'redux';
import { replace } from '@etienne-dldc/redux-router-location';
import { requestedEntity, State as RequestedState } from './requestedEntity';
import { Route, Routes, RouteType } from 'module/Model/Routes';
import { RouterAction } from './RouterAction';
import { RouterSelector } from './RouterSelector';
import { Stabilizer, Stabilizers } from 'module/Redux';

export * from './RouterSelector';
export * from './RouterAction';

const getRoutesReducer = (routes: Routes): Reducer<Routes> => {
  return (s: Routes = routes) => s;
};

const getPreviewReducer = (state: MelezeConfigPreview): Reducer<MelezeConfigPreview> => {
  return (s: MelezeConfigPreview = state) => s;
};

export const getRouterReducer = (routes: Routes, preview: MelezeConfigPreview): Reducer<State> =>
  combineReducers<State>({
    routes: getRoutesReducer(routes),
    preview: getPreviewReducer(preview),
    lastGridRoute: lastGridRouteEntity.reducer,
    requested: requestedEntity.reducer,
  });

const langRouteStabilizer: Stabilizer = (s: State) => {
  const pathHasLang = RouterSelector.selectPathnameHasLang(s);
  const route = RouterSelector.selectRoute(s);
  if (pathHasLang === false) {
    const search = RouterSelector.selectSearch(s);
    return replace({
      search,
      pathname: PathUtils.addLangToPath(route, PathUtils.defaultLang),
    });
  }
  return null;
};

const lastGridRouteStabilizer: Stabilizer = (s: State) => {
  const lastGridRoute = RouterSelector.selectLastGridRoute(s);
  const route = RouterSelector.selectMatchingRoute(s);
  if (route.type === RouteType.Home || route.type === RouteType.Category) {
    if (lastGridRoute === null) {
      return RouterAction.setLastGridRoute(route);
    }
    if (lastGridRoute.type !== route.type || lastGridRoute.id !== route.id) {
      return RouterAction.setLastGridRoute(route);
    }
  }
  return null;
};

export const stabilizers: Stabilizers = [langRouteStabilizer, lastGridRouteStabilizer];

export type State = CoreState & {
  routes?: Routes;
  preview?: MelezeConfigPreview;
  lastGridRoute?: Route | null;
  requested?: RequestedState;
};



// WEBPACK FOOTER //
// ./src/module/Redux/Router/index.ts